function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#57a4ff;}.cls-2{fill:#cbfff2;}.cls-3{fill:#43bfbf;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  "data-name": "\\u5716\\u5C64 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_1-2",
  "data-name": "\\u5716\\u5C64 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M248,200a96,96,0,0,0-94.66,112H342.68A94.33,94.33,0,0,0,344,296,96,96,0,0,0,248,200Zm16,104H232V232h32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M248,200a96,96,0,1,0,94.66,112A94.33,94.33,0,0,0,344,296,96,96,0,0,0,248,200Zm16,160H232V328h32ZM232,232h32v72H232Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M430.86,106.25C427.86,47.19,378.75,0,319,0a112.4,112.4,0,0,0-94,51,104.11,104.11,0,0,0-121,61A104,104,0,0,0,93,319.42a7.88,7.88,0,0,0,3,.58h50.8a104,104,0,0,0,202.4,0H392a8,8,0,0,0,2.83-.51,112,112,0,0,0,36-213.24ZM248,384a88,88,0,1,1,88-88A88,88,0,0,1,248,384ZM454.3,273.4a95.62,95.62,0,0,1-62.89,30.32,7.51,7.51,0,0,0-1.56.28H351.72q.3-4,.3-8a104,104,0,0,0-208,0q0,4,.3,8h-46a7.46,7.46,0,0,0-1.62-.3A88,88,0,0,1,104,128c1.57,0,3.2.05,5,.15a8,8,0,0,0,8-5.34A88.11,88.11,0,0,1,226.33,68a8,8,0,0,0,9.33-3.65A96,96,0,0,1,415,111.6a8,8,0,0,0,5,7.39A96,96,0,0,1,454.3,273.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M136,328H80a8,8,0,1,0,0,16h56a8,8,0,0,0,0-16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M432,328H360a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M264,320H232a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8V328A8,8,0,0,0,264,320Zm-8,32H240V336h16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M264,224H232a8,8,0,0,0-8,8v72a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8V232A8,8,0,0,0,264,224Zm-8,72H240V240h16Z"
})));

var SvgWrongNetwork = function SvgWrongNetwork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 496.03 400.02",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWrongNetwork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wrong-network.ce6c61e0.svg";
export { ForwardRef as ReactComponent };